import { modelServices } from '@/app/shared/services/client-agent-service.js';
import { httpClient } from '@/app/shared/services/http-client/http-client.js';
export class ScreeningService {
    // constructor() {
    //     this.GetAllCostCentersList = modelServices.baseUrl + modelServices.getFinanceServiceName("GetAllCostCentersList").URL;
    // }
    getMedicationGenericName(callback, errCallback) {
        httpClient.get(modelServices.baseUrl + modelServices.getCPGPmgtServiceName("GenericRetrieval").URL).then(callback).catch(errCallback);
    }

    getPatientDiease(patientId, callback, errCallback) {
        //debugger
        httpClient.get(modelServices.baseUrl + modelServices.getScreeningModuleSeviceName("GetPatientDiease").URL + "?patientID=" + patientId).then(callback).catch(errCallback);
    }
    GetAllDiseases(callback, errCallback) {
        httpClient.get(modelServices.baseUrl + modelServices.getScreeningServiceName("GetAllDiseases").URL).then(callback).catch(errCallback);
    }
    GetPatientFamilyHistory(patientId, callback, errCallback) {
        //debugger
        httpClient.get(modelServices.baseUrl + modelServices.getScreeningModuleSeviceName("GetPatientFamilyHistory").URL + "PatientId=" + patientId).then(callback).catch(errCallback);
    }
    GetAllContraception(callback, errCallback) {
        //debugger;
        httpClient.get(modelServices.baseUrl + modelServices.getScreeningServiceName("GetAllContraception").URL).then(callback).catch(errCallback);
    }
    GetSocialLookUpList(callback, errCallback) {
        debugger;
        httpClient.get(modelServices.baseUrl + modelServices.getScreeningModuleSeviceName("GetSocialLookUpList").URL).then(callback).catch(errCallback);
    }
    GetMedicationLookUp(callback, errCallback) {
        debugger;
        httpClient.get(modelServices.baseUrl + modelServices.getScreeningModuleSeviceName("GetMedicationLookUp").URL).then(callback).catch(errCallback);
    }
    
    GetSocialMedicalHistory(patientId, callback, errCallback) {
        debugger
        httpClient.get(modelServices.baseUrl + modelServices.getScreeningModuleSeviceName("GetSocialMedicalHistory").URL + "PatientId=" + patientId).then(callback).catch(errCallback);
    }
    GetPatientSurgicalHistory(patientId, callback, errCallback) {
        debugger
        httpClient.get(modelServices.baseUrl + modelServices.getScreeningModuleSeviceName("GetPatientSurgicalHistory").URL + "PatientId=" + patientId).then(callback).catch(errCallback);
    }

    GetProduct(productName, callback, errCallback) {
        httpClient.get(modelServices.baseUrl + modelServices.getScreeningModuleSeviceName("ProductByClassificationOData").URL + "classificationID=9&productText=&$filter=((IsActive eq true ) and (contains(tolower(ProductName),tolower('" + productName + "'))))&$top=100" ).then(callback).catch(errCallback);
    }
    GetPatientMedicationHistory(patientId, callback, errCallback) {
        //debugger
        httpClient.get(modelServices.baseUrl + modelServices.getScreeningModuleSeviceName("GetPatientMedicationHistory").URL + "PatientId=" + patientId).then(callback).catch(errCallback);
    }
    GetPatientAllergies(patientId, callback, errCallback) {
        //debugger
        httpClient.get(modelServices.baseUrl + modelServices.getScreeningModuleSeviceName("GetPatientAllergies").URL + "PatientID=" + patientId).then(callback).catch(errCallback);
    }
    GetAllergyLookUpList(callback, errCallback) {
        //debugger
        httpClient.get(modelServices.baseUrl + modelServices.getScreeningModuleSeviceName("GetAllergyLookUpList").URL).then(callback).catch(errCallback);
    }
    // Get Medication Trade Name
    GetMedicationTradeNameOData(filter, callback, errCallback) {
        httpClient.get(modelServices.baseUrl + modelServices.getCPOEServiceName("GetTradeNamesOData").URL + filter).then(callback).catch(errCallback);

    }
    GetTradeNameDetails(tradeId, callback, errCallback) {
        httpClient.get(modelServices.baseUrl + modelServices.getCPOEServiceName("GetTradeNameDetails").URL + '?tradeNameID=' + tradeId).then(callback).catch(errCallback);

    }

    GetMedications(MedicationText, callback, errCallback) {
        //debugger
        httpClient.get(modelServices.baseUrl + modelServices.getScreeningModuleSeviceName("MedicationOData").URL + "productText=" + MedicationText + "&$top=100").then(callback).catch(errCallback);
    }

    getGenericName(callback, errCallback) {
        httpClient.get(modelServices.baseUrl + modelServices.getScreeningModuleSeviceName("GenericRetrieval").URL).then(callback).catch(errCallback);
    }
    GetPatientObGyn(patientId, callback, errCallback) {
    debugger
        httpClient.get(modelServices.baseUrl + modelServices.getScreeningModuleSeviceName("GetPatientObGyn").URL + "PatientId=" + patientId).then(callback).catch(errCallback);
    }
    SavePatientQuestionnaire(patientModel, callback, errCallback) {
        debugger
        const url = modelServices.baseUrl + modelServices.getScreeningModuleSeviceName("SavePatientQuestionnaire").URL;
        const options = {
            url: url,
            method: 'POST',
            headers: { 'content-type': 'application/json; charset=utf-8' },
            data: JSON.stringify(patientModel)
        };
        httpClient(options).then(callback).catch(errCallback);
    }
    GetObsGynLookup( callback, errCallback) {
        debugger
        httpClient.get(modelServices.baseUrl + modelServices.getScreeningModuleSeviceName("GetObsGynLookup").URL).then(callback).catch(errCallback);
    }
    
}
const screeningService = new ScreeningService();

export { screeningService };